// Grade ranges for percentage KPIs
// Using [min, max) intervals (inclusive start, exclusive end) to avoid overlap
// grade1: 0-29.99%, grade2: 30-49.99%, grade3: 50-69.99%, grade4: 70-100%
export const GRADES_VALUES = {
  grade1: [0, 30],    // [0, 30)   - Poor: 0% to <30%
  grade2: [30, 50],   // [30, 50)  - Fair: 30% to <50%
  grade3: [50, 70],   // [50, 70)  - Good: 50% to <70%
  grade4: [70, 100]   // [70, 100] - Excellent: 70% to 100% (inclusive)
}

export const GRADES_COLOR = {
  grade1: {
    barColorPrimary: {
      backgroundColor: '#b2102f'
    },
    colorPrimary: {
      backgroundColor: '#ef9a9a'
    }
  },
  grade2: {
    barColorPrimary: {
      backgroundColor: '#ff6333'
    },
    colorPrimary: {
      backgroundColor: '#ffab91'
    }
  },
  grade3: {
    barColorPrimary: {
      backgroundColor: '#b2a300'
    },
    colorPrimary: {
      backgroundColor: '#fff7b0'
    }
  },
  grade4: {
    barColorPrimary: {
      backgroundColor: '#00a152'
    },
    colorPrimary: {
      backgroundColor: '#b7deb8'
    }
  }
}
